// @flow
import styled from 'styled-components';
import { Button as CoreButton } from '@finect/tabular-core/Button';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const WrapperSummary = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column-reverse;
  justify-content: space-between;

  margin-bottom: 16px;

  > div {
    flex-grow: 1;
    margin-right: 36px;
  }

  ${minMediaQueries.tablet`
    flex-flow: row;
  `}
`;

export const Inner = styled.div`
  min-height: 460px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.terciaryL};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 5px 10px rgb(0 0 0 / 0.0973);
  margin-bottom: 72px;

  > a {
    margin-top: 8px;
  }
`;

export const BlockInner = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.terciaryD};

  > span {
    ${getFont(0)}
    font-weight: 700;
  }

  ${maxMediaQueries.miniDesktop`
    flex-flow: column;
    align-items: center;
  `}
`;

export const Block = styled.div`
  width: 100%;

  > span {
    ${getFont(0)}
    font-weight: 700;
  }

  ${minMediaQueries.miniDesktop`
    width: 65%;
    margin-bottom: 12px;
  `}
`;

export const SummaryPanel = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SummaryBlock = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 50%;
  height: 72px;
  padding: 6px 12px;
  border: 1px solid ${({ theme }) => theme.colors.primaryL};
  border-radius: 10px;
  margin: 6px;
  background-color: ${({ theme }) => theme.colors.primaryLL};
  color: ${({ theme }) => theme.colors.ui};

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }

  div {
    small {
      ${getFont(0)}
    }
  }

  div:first-of-type {
    ${getFont(0, 'xcompact')}
    color: ${({ theme }) => theme.colors.fontL};
  }

  div:last-of-type {
    ${getFont(2, 'xcompact')}
    color: ${({ theme }) => theme.colors.uiDDD};
  }
`;

export const SummaryValueBlock = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const HealthMetric = styled.b`
  font-weight: 900;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const PillSummary = styled.iframe`
  max-width: 270px;
  height: 410px;
  max-height: 400px;
  border: none;
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows.extraBlack};
  margin: 16px 0;

  #app {
    overflow: hidden;
  }

  ${minMediaQueries.phone`
    min-width: 400px;
  `}
`;

export const Button = styled(CoreButton)`
  display: flex;
  align-items: center;
  margin: 0;
  height: 36px;
  width: auto;

  background-color: ${({ theme }) => theme.plus.primary};

  :not([disabled]):hover {
    background-color: ${({ theme }) => theme.plus.primary};
    opacity: 0.9;
  }
`;
